/**
 * SocialProofStep — create-wizard step 5 (W12 Part B, Task B3).
 *
 * Reviews, ratings, study cases and big numbers the AI may cite. ONE table over
 * four path planes: each row carries the plane it writes, so the dialog folds
 * the selection back into `@review[…]` / `@rating[…]` / `@studyCase[…]` /
 * `@bigNumber[…]`.
 */
import React from 'react';
import { Typography } from '@mui/material';
import { STRATEGY_LIST } from '@test-kit/selectors/strategy-list';
import { SelectionTable } from '../SelectionTable';
import type { SocialProofRow } from '../useWizardSourceRows';

export interface SocialProofStepProps {
  rows: SocialProofRow[];
  selectedIds: string[];
  onSelectedIdsChange: (ids: string[]) => void;
  loading?: boolean;
  error?: string | null;
}

export const SocialProofStep: React.FC<SocialProofStepProps> = ({
  rows,
  selectedIds,
  onSelectedIdsChange,
  loading = false,
  error = null,
}) => (
  <SelectionTable<SocialProofRow>
    rows={rows}
    selectedIds={selectedIds}
    onSelectedIdsChange={onSelectedIdsChange}
    loading={loading}
    error={error}
    searchPlaceholder="Search social proof"
    summary={`${selectedIds.length} of ${rows.length} selected · the AI may cite only what is selected`}
    emptyState={(
      <Typography variant="body2" color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
        No reviews, ratings, study cases or big numbers on this project yet — generation works without them.
      </Typography>
    )}
    aria-label="Social proof"
    data-testid={STRATEGY_LIST.wizardTable('proof')}
  />
);

SocialProofStep.displayName = 'SocialProofStep';
